var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/pull-to-refresh.tsx";
const _excluded = ["children", "onRefresh"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PTRComponent from 'react-simple-pull-to-refresh';
import { Spinner } from 'soapbox/components/ui';

/**
 * PullToRefresh:
 * Wrapper around a third-party PTR component with Soapbox defaults.
 */
const PullToRefresh = _ref => {
  let {
    children,
    onRefresh
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const handleRefresh = () => {
    if (onRefresh) {
      return onRefresh();
    } else {
      // If not provided, do nothing
      return Promise.resolve();
    }
  };

  return /*#__PURE__*/React.createElement(PTRComponent, _extends({
    onRefresh: handleRefresh,
    pullingContent: /*#__PURE__*/React.createElement(React.Fragment, null) // `undefined` will fallback to the default, while `<></>` will render nothing
    ,
    refreshingContent: onRefresh ? /*#__PURE__*/React.createElement(Spinner, {
      size: 30,
      withText: false,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 38
      }
    }) : /*#__PURE__*/React.createElement(React.Fragment, null),
    pullDownThreshold: 67,
    maxPullDownDistance: 95,
    resistance: 2
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(React.Fragment, null, children));
};

export default PullToRefresh;